(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-overview-selector-score/assets/javascripts/coupon-overview-selector-score.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-overview-selector-score/assets/javascripts/coupon-overview-selector-score.js');
"use strict";

const {
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const {
  Coupon,
  useCouponContext
} = svs.components.tipsen.couponComponents;
const {
  DescriptionSize
} = svs.components.lbUi.participants.constants;
const {
  getOutcomeLabelsForEventType
} = svs.components.sport.tipsenShared;
const {
  makeSelectEventOutcomesFromBitmap,
  selectIsCouponExternal
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  useCurrentDraw,
  useCurrentDrawEvent
} = svs.components.tipsen.drawProvider.hooks;
const {
  CouponOverviewReduce
} = svs.components.tipsen.couponOverviewParts;
const {
  CouponOverviewExternal
} = svs.components.tipsen.couponOverviewExternal;
const {
  clx
} = svs.components.lbUtils;
const CouponOverviewRow = _ref => {
  let {
    awayParticipant,
    eventNumber,
    homeParticipant,
    nameSize
  } = _ref;
  const {
    sportType
  } = useCurrentDraw() || {};
  const {
    eventTypeId
  } = useCurrentDrawEvent() || {};
  const {
    couponId
  } = useCouponContext();
  const outcomeLabels = useMemo(() => getOutcomeLabelsForEventType(eventTypeId, sportType), [eventTypeId, sportType]);
  const selectOutcomes = useMemo(makeSelectEventOutcomesFromBitmap, []);
  const boardIndex = 0;
  const selectionsHome = useSelector(state => selectOutcomes(state, couponId, boardIndex, eventNumber, 0));
  const selectionsAway = useSelector(state => selectOutcomes(state, couponId, boardIndex, eventNumber, 1));
  const outcomesHome = useMemo(() => {
    const outcomesArray = outcomeLabels.map((outcome, index) => ({
      sign: outcome.text,
      isSelected: Boolean(selectionsHome[index])
    }));
    return [...outcomesArray];
  }, [outcomeLabels, selectionsHome]);
  const outcomesAway = useMemo(() => {
    const outcomesArray = outcomeLabels.map((outcome, index) => ({
      sign: outcome.text,
      isSelected: Boolean(selectionsAway[index])
    }));
    return [...outcomesArray];
  }, [outcomeLabels, selectionsAway]);
  return React.createElement("div", {
    className: "pg_coupon_overview_row"
  }, React.createElement("div", {
    className: "pg_coupon_overview_row__home_participant"
  }, React.createElement(Coupon.Participant, {
    nameSize: nameSize,
    participant: homeParticipant
  })), React.createElement("div", {
    className: "pg_coupon_overview_row__home_selections"
  }, React.createElement(Coupon.OutcomeRow, {
    boardIndex: boardIndex,
    className: "pg_coupon_overview_row__bet_buttons_grid",
    eventNumber: eventNumber,
    outcomeGroupIndex: 0,
    outcomes: outcomesHome
  })), React.createElement("div", {
    className: "pg_coupon_overview_row__away_participant"
  }, React.createElement(Coupon.Participant, {
    nameSize: nameSize,
    participant: awayParticipant
  })), React.createElement("div", {
    className: "pg_coupon_overview_row__away_selections"
  }, React.createElement(Coupon.OutcomeRow, {
    boardIndex: boardIndex,
    eventNumber: eventNumber,
    outcomeGroupIndex: 1,
    outcomes: outcomesAway
  })), React.createElement("div", {
    className: "pg_coupon_overview_row__reductions"
  }, React.createElement(CouponOverviewReduce, {
    eventNumber: eventNumber
  })));
};
const CouponOverviewSelectorScore = _ref2 => {
  let {
    isCompact = false
  } = _ref2;
  const {
    couponRows,
    couponId
  } = useCouponContext();
  const isExternal = useSelector(state => selectIsCouponExternal(state, couponId));
  const blockName = 'pg_coupon_overview_selector';
  const classNames = clx(blockName, "".concat(blockName, "--show-selected"), {
    ["".concat(blockName, "--compact")]: isCompact,
    'margin-xs-h-1': !isCompact
  });
  if (isExternal) {
    return React.createElement("div", {
      className: classNames
    }, React.createElement(CouponOverviewExternal, null));
  }
  return React.createElement("div", {
    className: classNames
  }, couponRows.map(row => React.createElement(CouponOverviewRow, {
    awayParticipant: row.awayParticipant,
    eventNumber: row.eventNumber,
    homeParticipant: row.homeParticipant,
    key: row.eventNumber,
    nameSize: isCompact ? DescriptionSize.Short : DescriptionSize.Full
  })));
};
setGlobal('svs.components.tipsen.couponOverviewSelectorScore.CouponOverviewSelectorScore', CouponOverviewSelectorScore);

 })(window);